import React from "react";
import { Breadcrumb, IBreadcrumbItem } from "@nuorder/components";
import { DATATEST } from "constants/integration";
import { IFolderSelection } from "./folder-navigation";

export interface IFolderNavigationBreadcrumbProps {
    breadcrumb: IBreadcrumbItem[];
    totalItems: number;
    isFetchingData: boolean;
    isSellectAllDisabled: boolean;
    canFetchMore: boolean;
    validItems: IFolderSelection[];
}

export const FolderNavigationBreadcrumb: React.FunctionComponent<IFolderNavigationBreadcrumbProps> = ({
    breadcrumb,
}) => (
    <Breadcrumb
        data-test={DATATEST.FOLDERS.BREADCRUMB}
        items={breadcrumb}
        maxDisplayedItems={3}
        overflowIndex={breadcrumb.length > 1 ? 1 : 0}
    />
);
